import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import { PIMG } from "../../data/initialData";
import Badge from "../../components/common/Badge";
import FImg from "../../components/common/FImg";
import Fld from "../../components/common/Fld";
import Dlg from "../../components/common/Dlg";
import { Th, Td, ABt, filt, exportCSV } from "../AdminUI";

export default function ProductsTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("products", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("products", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12 }}>
        <ABt onClick={() => exportCSV("products", db.products || [], [["ID", "id"], ["Name", "name"], ["Category", "category"], ["Price", "price"], ["Stock", "stock"], ["Unit", "unit"], ["Compatible", "compat"], ["Status", "status"]], toast)}>Export CSV</ABt>
        <ABt variant="orange" onClick={() => { setForm({ name: "", category: "Inlet", price: "", stock: "", unit: "Each", compat: "", status: "active", desc: "" }); setModal(true); }}>+ Add Product</ABt>
      </div>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, overflow: "auto", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 680 }}>
          <thead><tr>{["#", "Img", "Name", "Category", "Price", "Stock", "Status", "Actions"].map(h => <Th key={h}>{h}</Th>)}</tr></thead>
          <tbody>
            {filt(db.products, ["name", "category"], srch).map(p => (
              <tr key={p.id}>
                <Td>{p.id}</Td>
                <Td><FImg src={PIMG[p.category]} h={32} style={{ width: 42, height: 32, objectFit: "cover", borderRadius: 6 }} /></Td>
                <Td bold blue>{p.name}</Td>
                <Td><span style={{ background: "#dbeafe", color: "#1e40af", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{p.category}</span></Td>
                <Td bold>Rs.{p.price.toLocaleString()}</Td>
                <Td><span style={{ color: p.stock <= 10 ? C.red : p.stock <= 20 ? C.amber : C.green, fontWeight: 700 }}>{p.stock}</span></Td>
                <Td><Badge v={p.status} /></Td>
                <td style={{ padding: "9px 11px", borderBottom: "1px solid #f1f5f9" }}>
                  <div style={{ display: "flex", gap: 5 }}>
                    <ABt onClick={() => { setForm({ ...p }); setModal(true); }}>Edit</ABt>
                    <ABt variant="red" onClick={() => del(p.id)}>Del</ABt>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && <Dlg title={form.id ? "Edit Product" : "Add Product"} onClose={close}>
        <Fld label="Product Name" value={form.name || ""} onChange={fs("name")} />
        <Fld label="Category" value={form.category || "Inlet"} onChange={fs("category")} opts={["Inlet", "Ferrule", "Gas", "Detector", "Column", "Oven", "Software", "Consumable"]} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Price (Rs.)" value={form.price || ""} onChange={fs("price")} type="number" /><Fld label="Stock" value={form.stock || ""} onChange={fs("stock")} type="number" /></div>
        <Fld label="Unit" value={form.unit || "Each"} onChange={fs("unit")} opts={["Each", "Pack of 5", "Pack of 10", "Pack of 50", "500mL", "Litre", "Licence", "Set of 5"]} />
        <Fld label="Compatible Instruments" value={form.compat || ""} onChange={fs("compat")} />
        <Fld label="Description" value={form.desc || ""} onChange={fs("desc")} rows={3} />
        <Fld label="Status" value={form.status || "active"} onChange={fs("status")} opts={["active", "inactive"]} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Add"} Product</ABt>
      </Dlg>}
    </>
  );
}
